// extracted by mini-css-extract-plugin
module.exports =  {"tooltipWrapper":"AjS80sYOx09kjpCnDYz_"};